import { fg } from '@atlassian/jira-feature-gating';

const NinCaterRichTextWithPlainTextRendererRelayProvider = {
	get(): boolean {
		return fg('nin_cater_rich_text_with_plain_text_renderer');
	},
};

export default NinCaterRichTextWithPlainTextRendererRelayProvider;
